import React, { useCallback } from "react";
import { FC } from "react";

import { Badge, Button, ButtonProps } from "react-bootstrap";

import { ReactSVG } from "react-svg";

import icon from "@assets/icons/streamline/Common-File-Edit--Streamline-Ultimate.svg";

import styles from "./CartButton.module.scss";

interface CartButtonProps extends ButtonProps {
  onClick: () => void;
  badgeNumber: number;
}

export const CartButton: FC<CartButtonProps> = ({ onClick, badgeNumber, ...rest }) => {
  const handleOnClick = useCallback(() => {
    onClick();
  }, [onClick]);

  return (
    <div>
      <Button
        {...rest}
        variant="none"
        onClick={handleOnClick}
        data-test-id="cart-button"
        className={styles["cart-button"]}
      >
        <ReactSVG src={icon} className={styles["svg-icon"]} />
        {badgeNumber > 0 && <Badge pill>{badgeNumber}</Badge>}
      </Button>
    </div>
  );
};
